import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
 import SDM_RO_data from './SDM_RO_Report';

// const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Dist_RO_data = async (params) => {  
        const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/sdms/dist_ro_report`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Dist_RO_Report = ({  trans_date,  heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading); 
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsLoad = useRef(null);  

    const handleDistClick = (trans_date,dist_code,dist_name_en) => {
        setRenderContentt(null);
        
        setTimeout(() => {
            setRenderContentt(
                <SDM_RO_data trans_date={trans_date} dist_code={dist_code} dist_name={dist_name_en}  heading={tabHeading}/>
            );
        }, 10);
        };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Dist_RO_data({trans_date});
               
                if (Array.isArray(response_data.data)) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [trans_date]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsLoad.current) {
            // detailsLoad.current.scrollIntoView({ behavior: 'smooth' , block: 'end'});
            const elementPosition = detailsLoad.current.offsetTop;
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
         }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }
    const totals = reportData.reduce(
        (acc, item) => {
          acc.tot_fps+=  parseFloat(item.tot_fps) || 0;
          acc.tot_order += parseFloat(item.tot_order) || 0;
          acc.tot_truck += parseFloat(item.tot_truck) || 0;
          acc.pending += parseFloat(item.pending) || 0;
          acc.received += parseFloat(item.received )|| 0;

          return acc;
        },
        {
            tot_fps: 0,
            tot_order: 0,
            tot_truck: 0,
            pending: 0,
            received: 0,
         }
      );
       
    return (
        <>

            <table align="center" width="50%" border={1}  ref={detailsLoad}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={19}>
                        {heading} on 
                        <font  style={{color: 'orange'}} > {trans_date}</font> 
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>District</th>
                        <th rowSpan={2}>No Of<br/>FPS</th>
                        <th rowSpan={2}>No Of<br/>Allocation<br/>Orders</th>
                        <th colSpan={3}>Truck Chits</th>
                     </tr>
                     <tr className="tableheader">
                        <th  >Total</th>
                        <th  >Received</th>
                        <th  >Pending for<br/>Receive</th>
                         </tr>
                     
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.dist_code}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                            <a style={{ cursor: 'pointer', color: 'blue' }}
                                role="button" tabindex="0"
                                onClick={() => handleDistClick(trans_date,item.dist_code,item.dist_name_en)} >
                                {item.dist_name_en}
                                </a>
                                </td>
                            <td style={{ textAlign: 'right' }}>{item.tot_fps}</td>
                            <td style={{ textAlign: 'right' }}>{item.tot_order}</td>
                            <td style={{ textAlign: 'right' }}>{item.tot_truck}</td>
                            <td style={{ textAlign: 'right' }}>{item.received}</td>
                            <td style={{ textAlign: 'right' }}>{item.pending}</td>
                           
                        </tr>
                    ))}
                </tbody>
                <tr className="tableheader">
              <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_fps}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_order}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_truck}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.received}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.pending}</td>

            </tr>
            </table>
           
            <br /><br />
            <div id="detailsERR">{renderContentt}</div>
        
        </>
    );
};

export default Dist_RO_Report;
